// Client-side form-validation vocabulary — the messages lib/validation.js's shared
// builders emit as KEYS, plus the two the canonical caller recipe needs (the toast on a
// refused submit, and the fallback when the API call itself fails).
//
// It lives in `common` on purpose: every plane has forms (tenant admin, super admin,
// public site, marketplace), so the namespace has to be the one all of them already
// bind. Keys are deliberately generic — a field-specific message belongs in that
// screen's own namespace, not here.
//
// `errors.saveFailed` is the fallback passed to extractApiError(); the only pre-existing
// neighbour, `errors.invalidFieldValue` (added with apiErrors.js), is the replacement for
// Pydantic's English prose INSIDE a 422 breakdown — a different sentence with a different
// job, so this is an addition, not a duplicate.
export default {
  "fr": {
      "validation.required": "Champ requis",
      "validation.tooLong": "Texte trop long",
      "validation.emailRequired": "Adresse e-mail requise",
      "validation.emailInvalid": "Adresse e-mail invalide",
      "validation.numberInvalid": "Nombre invalide",
      "validation.fixHighlighted": "Veuillez corriger les champs signalés",
      "validation.frRequired": "Le contenu en français est requis",
      "validation.anyLangRequired": "Renseignez au moins une langue (FR ou EN)",
      "errors.saveFailed": "Échec de l’enregistrement"
  },
  "en": {
      "validation.required": "Required field",
      "validation.tooLong": "Text is too long",
      "validation.emailRequired": "Email address required",
      "validation.emailInvalid": "Invalid email address",
      "validation.numberInvalid": "Invalid number",
      "validation.fixHighlighted": "Please fix the highlighted fields",
      "validation.frRequired": "French content is required",
      "validation.anyLangRequired": "Fill in at least one language (FR or EN)",
      "errors.saveFailed": "Save failed"
  },
  "es": {
      "validation.required": "Campo obligatorio",
      "validation.tooLong": "El texto es demasiado largo",
      "validation.emailRequired": "Se requiere un correo electrónico",
      "validation.emailInvalid": "Correo electrónico no válido",
      "validation.numberInvalid": "Número no válido",
      "validation.fixHighlighted": "Corrija los campos señalados",
      "validation.frRequired": "El contenido en francés es obligatorio",
      "validation.anyLangRequired": "Complete al menos un idioma (FR o EN)",
      "errors.saveFailed": "No se pudo guardar"
  },
};
